var module = 'signin', name = 'signin/config/locales/en.json', content = {
  "signin": {
    "titles": {
      "my_account": "My account",
      "why.hin": "Why must I provide my date of birth and my Health Insurance Number?",
      "why.phin": "Why are date of birth and Personal Health Identification Number required?",
      "why.email": "Why is an email address required?",
      "no_account_no_new": "Sorry! No records match the information provided.",
      "linked_patient_error": "Sorry! It is not possible to link that person with your account.",
      "registration.success": "Congratulations! Your new account is almost ready",
      "already_account_mismatch": "Your personal information indicates that you have a file at our clinic.",
      "already_account_match": "Your email address is already associated to an account elsewhere in the network:",
      "good_news": "Good news! You are already signed up.",
      "create_password": "Create password",
      "password": "Password",
      "expired_activation": "The activation link has unfortunately expired.",
      "already_used_email": "Sorry! This email address is already associated with a file at the clinic.",
      "alredy_registered": "Good news! You are already registered.",
      "forgotten_password": "Forgot your password?",
      "reset_email_sent": "Check your inbox!",
      "no_account_found": "Sorry! We were unable to find an account with the provided email address.",
      "expired_reset": "Sorry, this link has expired",
      "forgot_password": "Forgot your password?",
      "reset_password": "Please choose a new password."
    },
    "labels": {
      "empty_state": "Select",
      "gender": "Gender",
      "first_name": "First name",
      "last_name": "Last name",
      "birthdate": "Birthdate",
      "city": "City",
      "phone": "Phone number",
      "hin": "Health Insurance Number",
      "phin": "Personal Health Identification Number",
      "hin_expiration": "Expiration date",
      "email": "Email address",
      "email_confirmed_label": "Enter your complete email address",
      "password": "Password",
      "password_confirmation": "Confirm password",
      "user_agreement": "I have read and I accept the <a href=\"/patient-agreement?locale=en\" target=\"_blank\">user agreement</a>",
      "day": "DD",
      "month": "Select",
      "month_full": "Month",
      "year_full": "Year",
      "year": "YYYY"
    },
    "options": {
      "gender": {
        "female": "Female",
        "male": "Male",
        "other": "Other"
      }
    },
    "messages": {
      "why.defaultHin": "This information confirms your identity and links your account to the correct file. If you do not have a HIN, please contact the clinic ${clinicNumber} to create your file and online account.",
      "why.phn": "This information confirms your identity and links your account to the correct file. If you do not have a PHN/PHIN, please contact the clinic ${clinicNumber} to create your file and online account.",
      "why.manitobaPhin": "This information confirms your identity and links your account to the correct file. If you do not have a PHIN, please contact the clinic ${clinicNumber} to create your file and online account.",
      "why.hin": "This information confirms your identity and links your account to the correct file.",
      "why.email": "Your email address is used to sign in to your account. It will also be used to share reminders and other information about your appointments.",
      "why.hospital_booking_email": "Your email address is used to sign in to your account. Be sure to choose an email address you can easily access.",
      "no_account_no_new": "Please note that the clinic is not accepting new patients. However, if you think you have a file at the clinic, please contact us at",
      "linked_patient.already_linked": "This person is already linked to another account.",
      "linked_patient.already_confirmed": "It is not possible to link this person as they are already managing their account.",
      "linked_patient.child_not_found": "The person was not found.",
      "linked_patient.cant_link_self": "You cannot link your own account.",
      "registration.success": "You will receive an activation email at the address you have provided. Activation is the last step before you can book an appointment online!",
      "registration.hospital_booking_success": "You will receive an activation email at the address you have provided. Activation is the last step before you can see your appointments online!",
      "already_account_mismatch": "However, the email address we have is not the same as indicated in the form. Please select the address you want to keep to sign in to your account.",
      "already_account_match": "To facilitate access to the platform, please use the same password to sign in.",
      "good_news": "Sign in to book an appointment.",
      "hospital_booking_good_news": "Sign in to see your appointments.",
      "password": "The password must be a minimum of 8 characters, contain at least one capital letter and one number.",
      "password_mismatch": "The passwords do not match.",
      "expired_activation": "Please create a new account and make sure to activate it immediately to access the online appointment booking.",
      "already_used_email": "If you want to add a family member to your account, contact us at <strong>{{phone}}</strong>.",
      "alredy_registered": "Connectez-vous pour prendre un rendez-vous.",
      "reset_password": "Please enter the email address used to sign in to your account. You will receive an email with the procedure to create a new password.",
      "reset_email_sent": "An email has been sent with a link which will allow you to create a new password.",
      "no_account_found": "Perhaps you registered with another address when signing up?",
      "expired_reset": "Please enter the email address used to sign in to your account and resume."
    },
    "actions": {
      "create": "Create my account",
      "connect": "Sign in",
      "continue": "Continue",
      "cancel": "Cancel",
      "forgotten_password": "Forgot your password?",
      "return_login_page": "Return to login page"
    },
    "notices": {
      "family_accounts": "For your convenience, several family members can be grouped into one account.<br>Visit the Manage my profile section for more information."
    },
    "errors": {
      "gender.required":"Please indicate your gender.",
      "first_name.required": "Please provide your first name.",
      "first_name.maxlength": "The field can not contain more than {{value}} characters.",
      "last_name.required": "Please provide your last name.",
      "last_name.maxlength": "The field can not contain more than {{value}} characters.",
      "birthdate.required": "Please provide your birthdate.",
      "city.required": "Please provide your city.",
      "city.maxlength": "The field can not contain more than {{value}} characters.",
      "phone.required": "Please provide a valid phone number.",
      "phone.maxlength": "The field can not contain more than {{value}} characters.",
      "hin.required": "Please provide your health insurance number.",
      "phin.required": "Please provide your Personal Health Identification Number.",
      "phin.number_only": "Personal Health Identification Number should be numbers only.",
      "phin.minlength": "Personal Health Identification Number must have 9 numbers.",
      "hin.invalid": "We’re having difficulty finding your file. Please call us for assistance.",
      "hin.alreadyTaken": "We’re having difficulty finding your file. Please call us for assistance.",
      "hin_expiration.required": "Please provide an expiration date.",
      "hin_expiration.invalid": "Please provide a valid expiration date.",
      "email.required": "Please provide your email address.",
      "email.invalid": "Please provide a valid email address.",
      "email.already_used": "This email address is already used.",
      "email.dont_exist": "This email address does not exist in our system.",
      "email.alreadyTaken": "You cannot use this email address because it already exists in our database.<br><br>If you want to create an account for your child or someone else, you can do it from your own account. You must use the \"Edit My Profile\" option from the top right menu.",
      "password.activated": "Your account has already been activated.",
      "password.required": "You forgot to put a password.",
      "password.minlength": "Your password must have more than {{value}} characters.",
      "password.maxlength": "Your password must have less than {{value}} characters.",
      "password.invalid": "Your password must contain at least one capital letter and one number.",
      "confirm_password.required": "You forgot to confirm your password.",
      "confirm_password.unmatch": "Your passwords do not match.",
      "user_agreement.required": "You must accept the terms of use.",
      "date.invalid": "Please enter a valid date."
    },
    "delegation_form": {
      "title": "Information about the person to link (optional)",
      "linked": {
        "title": "Person to link?",
        "description": "You can provide information about the person for which you will take appointments (child, dependent, etc.)."
      },
      "linked_multiple": {
        "title": "You need to link more than one person?",
        "description": "Once the registration has been completed, you will be able to link more people to your account."
      },
      "same_contact_info": "Same contact information as me"
    }
  },
  "login": {
    "title": "Online appointment booking",
    "hospital_booking_title": "Patient Portal",
    "subtitle": "Are you already registered?",
    "instruction": "Log in to book an appointment.",
    "email_label": "Username",
    "password_label": "Password",
    "login_button_message": "Log in",
    "error": {
      "required": "Required field",
      "pattern": "Incorrect field format",
      "bad_credentials": "Your email or password is incorrect",
      "patient_not_created": "First, you should create your account with this clinic",
      "link_no_longer_valid": "The provided link is no longer valid"
    },
    "side.title": "Not registered yet?",
    "messages.accept_new": "The clinic is happy to accept new patients. Create your account now to gain access to the online appointment booking!",
    "messages.refuse_new": "Please note that the clinic is not accepting new patients. You must have a record at the clinic to create an account and book an online appointment.",
    "messages.hospital_booking_sign_up": "Sign up to see your past and upcoming appointments!",
    "actions.create": "Create my account"
  },
  "activation": {
    "title": "Create password",
    "legal_notice_agree_checkbox": "I have read and I accept the <a ui-sref=\"patient_agreement({locale: activationForm.$translate.use()})\" target=\"_blank\">user agreement</a>",
    "password_creation_title": "You will use the email address in your file and a password to login.",
    "choose_password_label": "Password",
    "confirm_password_label": "Confirm password",
    "password_restricted_label": "The password must be a minimum of 8 characters, contain at least one capital letter and one number.",
    "validation_button_message": "Log in",
    "error": {
      "forgot_to_enter_password": "You forgot to put a password",
      "password_too_short": "Your password must have more than 8 characters",
      "password_too_long": "Your password must have less than 256 characters",
      "password_invalid": "Your password must contain at least one capital letter and one number",
      "forgot_to_confirm_password": "You forgot to confirm your password",
      "password_not_match": "Your passwords do not match",
      "notice_not_accepted": "You must accept the terms of use"
    }
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./signin/config/locales/en.json
// module id = 787
// module chunks = 0